import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { appConfig } from "../config/app.config";
import { updateState } from "../redux/service-slice";
import { setQuizWasOpened } from "../redux/quiz-slice";

export const useConfig = () => {
  const dispatch = useDispatch();
  const { env, demo_quiz_id } = appConfig();

  useEffect(() => {
    if (!appConfig().plugin && env == "development") {
      dispatch(updateState({ quizId: demo_quiz_id }));
      dispatch(setQuizWasOpened());
    }
  }, [dispatch, demo_quiz_id, env]);
};